module.exports = __webpack_public_path__ + "img/lap-topper@2x.ca1d972b.png";